module.exports = __webpack_public_path__ + "static/Salesforce-fa889365f38ff2521b583e9a70110f76.png";